import React from 'react';

import ms1 from '../../images/mission/healthcare.png';
import ms2 from '../../images/mission/house.png';
import ms3 from '../../images/mission/education.png';
import ms4 from '../../images/mission/lamp.png';
import ms5 from '../../images/mission/star.png';
import ms6 from '../../images/mission/idea.png';

import './style.css';

const Mission = (props) => {
  return (
    <div className={`wpo-mission-area ${props.subclass}`}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='wpo-section-title max-width'>
              <span>What We Do?</span>
              <h2>
              Our projects supports Six Programs that benefit vulnerable children and the well-being of their families.
              </h2>
            </div>
          </div>
        </div>
        <div className='wpo-mission-wrap'>
          <div className='row'>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-5'>
                  <img src={ms3} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Education</h2>
                  <p>
                    LHCF Provide educational support by enrolling children back
                    to schools.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item mb-4'>
                <div className='wpo-mission-icon-6'>
                  <img src={ms1} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Healthcare</h2>
                  <p>
                    LHCF Provide healthcare cards, mosquito nets and disease
                    prevention trainings.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-7'>
                  <img src={ms2} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Affordable Housing Support</h2>
                  <p>
                    LHCF support families in finding safe and affordable rental
                    homes.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-8'>
                  <img src={ms4} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Business Creation</h2>
                  <p>
                    LHCF creates small businesses that generates income to
                    vulnerable families.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-8'>
                  <img src={ms5} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Talent Development</h2>
                  <p>
                    LHCF provides financial support that helps develop
                    children’s talents.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-8'>
                  <img src={ms6} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Counseling and Psycho-Therapy</h2>
                  <p>
                    LHCF provide emotional, psychological, and counseling to
                    children and families.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
